import {useState} from 'react'
import {Button, Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import {useAppSelector} from '../../../../../redux/hooks'
import {appSelector} from '../../../../../redux/slices/appSlices'
import {mutateJBPPrice} from '../../../../../services/fetcher'
import {IMutateJBPPricePayload} from '../../../../../services/types'

export const ButtonSubmit = () => {
  const {t} = useTranslation()
  const {jbpDetail: jbp} = useAppSelector(appSelector)
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleChange = async () => {
    if (!jbp || !jbp.id) return

    try {
      setIsLoading(true)

      const payload: IMutateJBPPricePayload = {
        product_code: jbp.product_code?.toString() ?? '',
        is_active: jbp?.is_active ?? false,
        regions:
          jbp?.regions?.map((item) => ({
            label: item?.region_name as string,
            value: item.id as number,
          })) ?? [],
        cities:
          jbp.cities?.map((item) => ({
            label: item?.city_name as string,
            value: item.id as number,
          })) ?? [],
        sales_org_code: jbp?.sales_org_code as string,
        customer_code: jbp?.customer_code as string,
        discount: (jbp?.discount as number).toString(),
        minimum_price: (jbp?.minimum_price as number)?.toString(),
        purchase_price: (jbp?.purchase_price as number)?.toString(),
        selling_price: (jbp?.selling_price as number)?.toString(),
        type: jbp?.type as 'jbp' | 'non-jbp',
        valid_from: jbp?.valid_from as string,
        valid_to: jbp?.valid_to as string,
      }

      await mutateJBPPrice(jbp.id, payload)

      const title = `${t('Harga Non JBP Berhasil di Ubah')}`
      await swal({title, icon: 'success'})

      if (jbp.type === 'jbp') navigate(`/master/price/jbp`)
      else navigate(`/master/price/non-jbp`)
    } catch (error: any) {
      const title = `${t(error.response.data.message)}`
      swal({title, icon: 'error'})
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Button variant='primary' disabled={isLoading} onClick={handleChange}>
      {isLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('ubah')}
    </Button>
  )
}

ButtonSubmit.defaultProps = {
  isLoading: false,
  isDisabled: true,
}
